import OrderList from "../components/order/OrderList";

function Order() {
  return (
    <div className="">
      <OrderList />
    </div>
  );
}

export default Order;
